export default __webpack_public_path__ + "static/media/gift-card 1.fb79f754.svg";